/* eslint-disable no-useless-escape */
export class RegexConstants {
  /**
   * Same regex as C# code, but removed ftp and unicode characters.
   * If you need to add flags, use
   * ```
   * new RegExp(RegexConstants.URL, '<<flags>>')
   * ```
   *
   * @static
   * @memberof RegexConstants
   * @see https://github.com/microsoft/referencesource/blob/f461f1986ca4027720656a0c77bede9963e20b7e/System.ComponentModel.DataAnnotations/DataAnnotations/UrlAttribute.cs#L46
   */
  public static URL = /^(https?):\/\/(((([a-z]|\d|-|\.|_|)|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d)|(([a-z]|\d)([a-z]|\d|-|\.|_|~)*([a-z]|\d)))\.)+(([a-z])|(([a-z])([a-z]|\d|-|\.|_|~)*([a-z])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~)|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~)|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~)|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~)|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/;
}
